import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import SettingsModalNav from 'containers/SettingsModalNav/SettingsModalNavContainer';
import classes from './SettingsModal.module.scss';

const SettingsModal = (props) => (
  <div className={classes.container}>
    <div className={classes.splitScreen}>
      <div className={classes.leftContainer}>
        <SettingsModalNav />
        <footer className={classes.settingsFooter}>
          {!props.isSSO && (
            <div className={classes.changePassword}>
              <a
                href={props.passwordLink}
                className={classes.passwordLink}
                rel="noopener noreferrer"
                target="_blank"
                data-testid="change-password-link"
              >
                <FormattedMessage id="settings.profile.password" defaultMessage="Change password" />
              </a>
            </div>
          )}
          <div className={classes.versionView}>
            <FormattedMessage
              id="settings.nav.version"
              defaultMessage={'Version {version}'}
              values={{ version: props.version }}
            />
          </div>
        </footer>
      </div>
      <div className={classes.rightContainer} data-testid="settingsModal">
        {props.children}
      </div>
    </div>
  </div>
);

SettingsModal.propTypes = {
  children: PT.element,
  version: PT.string,
  passwordLink: PT.string,
  isSSO: PT.bool
};

export default injectIntl(SettingsModal);
